import { render, staticRenderFns } from "./FollowedByDetails.vue?vue&type=template&id=e502f356"
import script from "./FollowedByDetails.vue?vue&type=script&lang=js"
export * from "./FollowedByDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports